__turbopack_context__.v({
  "UiDropdown": "dropdown-module__7FlAma__UiDropdown",
  "UiDropdown__group": "dropdown-module__7FlAma__UiDropdown__group",
  "UiDropdown__group__item": "dropdown-module__7FlAma__UiDropdown__group__item",
  "UiDropdown__group__item__danger": "dropdown-module__7FlAma__UiDropdown__group__item__danger" + " " + "dropdown-module__7FlAma__UiDropdown__group__item",
  "UiDropdown__group__item__default": "dropdown-module__7FlAma__UiDropdown__group__item__default" + " " + "dropdown-module__7FlAma__UiDropdown__group__item",
});
